module.exports = __webpack_public_path__ + "static/media/BC_Timeless_Piazza_Ind.Blue.55210a21.png";